import React, { useState } from "react";
import Styles from "./ForgetPassword.module.css";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { updatePassword } from "../../../Services/ApiCalling/Auth";
import { toast } from "react-toastify";
import { decryptData } from "../../../commons/Decode";
import Popup from "../../../commons/PopupModal/Popup";

const ResetPassword = ({ username, otp, onPasswordReset }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const validatePassword = () => {
    if (!password.trim()) {
      toast.error("Please enter a new password");
      return false;
    }
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long");
      return false;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return false;
    }

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialChar) {
      toast.error(
        "Password must contain at least one uppercase letter, lowercase letter, number, and special character",
      );
      return false;
    }
    return true;
  };

  const handleResetPassword = async () => {
    if (!validatePassword()) return;

    setLoading(true);
    try {
      const response = await updatePassword(username, password);

      if (response?.status === 200 || response?.status === 201) {
        setSuccessMessage(true);
      } else {
        let data = null;
        if (response?.data) {
          try {
            data = await decryptData(response.data);
          } catch (decryptError) {
          }
        }

        const errorMessage =
          data?.error ||
          data?.message ||
          "Failed to reset password. Please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      let errorMessage = "Password reset failed. Please try again.";
      let errorData = null;

      if (error?.response?.data) {
        try {
          errorData = await decryptData(error.response.data);
        } catch (decryptError) {
        }
      } else if (error?.data) {
        try {
          errorData = await decryptData(error.data);
        } catch (decryptError) {
        }
      }

      if (errorData?.error) {
        errorMessage = errorData.error;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleResetPassword();
    }
  };

  const handleConfirm = () => {
    setSuccessMessage(false);
    onPasswordReset();
  };
  return (
    <>
      <Popup
        open={successMessage}
        handleClose={() => setSuccessMessage(false)}
        isInForgot={true}
        onClick={handleConfirm}
      />
      <div className={Styles.loginContainer}>
        <div className={Styles.loginDisplayContainer}>
          <div className={Styles.loginMainCont}>
            <div className={Styles.loginCompDisplayNameCont}>
              <div className={Styles.compNameText}>GNA Energy</div>
              <div className={Styles.platformText}>Reset Password</div>
            </div>

            <div className={Styles.loginHeadingCont}>
              <div className={Styles.loginHeadingText}></div>
              <div>
                Please enter your new password for <strong>{username}</strong>
              </div>
            </div>

            <div className={Styles.inputMainCOnt}>
              <div className={Styles.loginInputCont}>
                <div className={Styles.loginInputElemCOnt}>New Password</div>
                <div className={Styles.inputFieldCont}>
                  <LockIcon style={{ fontSize: "16px" }} />
                  <div className={Styles.inputField}>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyPress={handleKeyPress}
                      placeholder="Enter new password"
                    />
                  </div>
                  {showPassword ? (
                    <span
                      onClick={() => setShowPassword(false)}
                      style={{ cursor: "pointer" }}
                    >
                      <VisibilityIcon style={{ fontSize: "16px" }} />
                    </span>
                  ) : (
                    <span
                      onClick={() => setShowPassword(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <VisibilityOffIcon style={{ fontSize: "16px" }} />
                    </span>
                  )}
                </div>
              </div>

              <div className={Styles.loginInputCont}>
                <div className={Styles.loginInputElemCOnt}>
                  Confirm Password
                </div>
                <div className={Styles.inputFieldCont}>
                  <LockIcon style={{ fontSize: "16px" }} />
                  <div className={Styles.inputField}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      onKeyPress={handleKeyPress}
                      placeholder="Confirm new password"
                    />
                  </div>
                  {showConfirmPassword ? (
                    <span
                      onClick={() => setShowConfirmPassword(false)}
                      style={{ cursor: "pointer" }}
                    >
                      <VisibilityIcon style={{ fontSize: "16px" }} />
                    </span>
                  ) : (
                    <span
                      onClick={() => setShowConfirmPassword(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <VisibilityOffIcon style={{ fontSize: "16px" }} />
                    </span>
                  )}
                </div>
              </div>

              <div
                style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}
              >
                Password must contain:
                <ul style={{ margin: "5px 0", paddingLeft: "20px" }}>
                  <li>At least 8 characters</li>
                  <li>One uppercase letter</li>
                  <li>One lowercase letter</li>
                  <li>One number</li>
                  <li>One special character</li>
                </ul>
              </div>
            </div>

            <button
              type="button"
              disabled={loading || !password || !confirmPassword}
              className={Styles.signinButton}
              onClick={handleResetPassword}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </div>

          <div className={Styles.bottomText}>
            © {new Date().getFullYear()}, <b>GNA Energy</b> Private Limited All
            Rights Reserved
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
